var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.003,
    viewBox: "0 0 18 18.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M20.71,5.63,18.37,3.29a1,1,0,0,0-1.41,0L13.84,6.41,12.61,5.2A1,1,0,0,0,11.2,6.61l.72.72L3.15,16.1a.491.491,0,0,0-.15.36V20.5a.5.5,0,0,0,.5.5H7.54a.469.469,0,0,0,.35-.15l8.77-8.77.72.72a1,1,0,0,0,1.41-1.41l-1.22-1.22,3.12-3.12A.99.99,0,0,0,20.71,5.63ZM6.92,19,5,17.08l8.06-8.06,1.92,1.92Z",
    transform: "translate(-3 -2.997)",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPickerIcon);
export default __webpack_public_path__ + "static/media/ColorPickerIcon.538c512819dda4d7ebcd42a01eff3326.svg";
export { ForwardRef as ReactComponent };